import { Breadcrumbs } from '@hhgtech/hhg-components'
import FormatInnerHTML from 'components/atoms/FormatInnterHTML'
import { domainLocales } from 'domainLocales'
import { IBreadcrumb } from 'interfaces/categories.interface'
import { useRouter } from 'next/router'
import HomeIcon from 'public/svg/home.svg'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

export const WrapperBreadcrumbs = styled.div`
  padding: 16px 0;
  color: #9495a0;
  &[data-is-border='true'] {
    border-bottom: 1px solid #f3f3f3;
  }
`

const Breadcrumb = (props: IBreadcrumb) => {
  const { breadcrumbItems = [], secondItem, isBorder } = props
  const { formatMessage: f } = useIntl()
  const { locale } = useRouter()
  const sL = locale || 'vi-VN' // standardized locale
  const icon = <HomeIcon />

  const breadcrumbs = breadcrumbItems.map((breadcrumb, index) => ({
    ...breadcrumb,
    active: index === breadcrumbItems.length - 1,
  }))

  return (
    <WrapperBreadcrumbs
      data-is-border={isBorder || false}
      className="breadcrumb-container"
    >
      <Breadcrumbs
        size="md"
        separator={<FormatInnerHTML template="&nbsp;/&nbsp;" />}
        pages={[
          {
            label: icon,
            value: '/',
            active: false,
            dataEventCategory: 'Breadcrumb',
            dataEventAction: 'Click',
            dataEventLabel: `https://${domainLocales[sL]}`,
          },
          {
            label: f({
              id: 'categories.breadcrumb.allCategories',
              defaultMessage: 'All Categories',
            }),
            value: '/categories',
            active: !breadcrumbItems.length,
            dataEventCategory: 'Breadcrumb',
            dataEventAction: 'Click',
            dataEventLabel: `https://${domainLocales[sL]}/categories`,
            ...secondItem,
          },
          ...breadcrumbs,
        ]}
      />
    </WrapperBreadcrumbs>
  )
}

export default Breadcrumb
